module.exports = __webpack_public_path__ + "img/tor-mit-zaun.8fd0d6b7.webp";